import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateCategoryQuery } from './types/template-category-query.type';
import type { TemplateCategory } from './types/template-category.type';

/**
 * Retrieves template categories from the API.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param query - Optional query parameters to filter the template categories.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing {@link TemplateCategory} data.
 * @throws Will throw an error if the request fails.
 */
export const getTemplateCategories = async (instance: KyInstance, query?: TemplateCategoryQuery) => {
  try {
    return await instance
      .get<OperationResultWithData<TemplateCategory[]>>(Uri.template.getTemplateCategories, { searchParams: query })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
